import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils.js'
//时间条件
const Q_TimeConditions = new GenerateEnum({
  TIME: { label: getLabelText({ key: 'remote.common.byTime', text: '按时间' }), value: 1 },
  NONE: { label: getLabelText({ key: 'remote.common.none', text: '无' }), value: 0 }
})

// 开关
const Q_Whether = new GenerateEnum({
  YES: { label: getLabelText({ key: 'remote.common.required', text: '必填' }), value: 1 },
  NO: { label: getLabelText({ key: 'remote.common.optional', text: '选填' }), value: 0 }
})

// 问卷选项
const Q_QuestionTypeList = new GenerateEnum({
  RADIO: { label: getLabelText({ key: 'remote.common.singleChoice', text: '单选' }), value: 0 },
  CHECK: { label: getLabelText({ key: 'remote.common.multipleChoice', text: '多选' }), value: 1 },
  TEXT: { label: getLabelText({ key: 'remote.common.text', text: '文本' }), value: 2 }
})

// 用户维度
const Q_UserTypeEnum = new GenerateEnum({
  ALL: { label: getLabelText({ key: 'remote.common.allUsers', text: '全部用户' }), value: 0 }
})

export { Q_TimeConditions, Q_Whether, Q_QuestionTypeList, Q_UserTypeEnum }



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/question.js